// apps/main/src/analytics.js — RUN AN. The one call into Plausible.
//
// The tag itself is injected server-side into public/_footer.html, which page-cache.js substitutes
// into the eight documents behind the nine marketing routes. NOTHING here loads a script or knows a
// domain; this is only the send.
//
// 🔴 WHY THIS IS A GUARDED NO-OP AND NOT A DIRECT window.plausible(...) CALL.
// The islands that import it do not all run on a page that carries the tag:
//
//   • The Clark widget is on /home today, but RUN CH2 is moving it to /clark, and /clark is an APP
//     surface that deliberately does NOT load Plausible — signed-in lawyers' work is not watched by
//     a third party, and usage_events already covers it. The day that move lands, these three calls
//     become inert on their own. That is the intended outcome, not a regression.
//   • The auth island (auth.bundled.js) mounts on marketing pages AND its AuthModal is reachable
//     from the SPA, where the tag is likewise absent.
//
// So `window.plausible` being undefined is a NORMAL, EXPECTED state on roughly half the surfaces
// this code reaches, and it must be silent there — never a console error counted against the "0
// product JS errors" bar, and never a thrown exception inside a click handler.
//
// ⚠️ The stub the snippet installs (`window.plausible = ... push(arguments)`) queues calls made
// BEFORE the async script finishes loading, so a chip clicked in the first 200ms is not lost. That
// is the queue's job, not ours — which is why this does not add a retry or a buffer of its own.

/**
 * Send one custom event. Returns true if it was handed to Plausible (or its pre-load queue),
 * false if the page carries no tag. The return value exists for the verification probes; no
 * product code branches on it.
 */
export function track(event, props) {
  try {
    if (typeof window === "undefined") return false;
    const p = window.plausible;
    if (typeof p !== "function") return false;
    p(event, props ? { props } : undefined);
    return true;
  } catch {
    // An analytics failure must never take a product interaction with it.
    return false;
  }
}

export default track;
